import { ref, computed } from 'vue'
import { defineStore } from 'pinia';

export const useSearchSpringCookiesStore = defineStore('searchSpringCookies', ()=>{
    let ssViewedProducts = computed({
        get(){
            if(typeof document === 'undefined'){
                return [];
            }
            let products = document.cookie
                    .split("; ")
                    .find((row) => row.startsWith("ssViewedProducts=")) ?? "ssViewedProducts=";
            return products.split('=')[1].split(',');
        },
        set(newVal){
            if(typeof document === 'undefined'){
                return;
            }
            newVal = newVal?.split(',').filter(prod => prod != '') ?? [];
            if(newVal.length == 0){
                document.cookie = `ssViewedProducts=;expires=${new Date(0).toUTCString()};`;
            }else{
                document.cookie = `ssViewedProducts=${newVal};expires=${new Date(new Date().setFullYear(new Date().getFullYear() + 7)).toUTCString()};`;
            }
        }
    })

    let ssCartProducts = computed({
        get(){
            if(typeof document === 'undefined'){
                return [];
            }
            let products = document.cookie
                    .split("; ")
                    .find((row) => row.startsWith("ssCartProducts=")) ?? "ssCartProducts=";
            return products.split('=')[1].split(',');
        },
        set(newVal){
            if(typeof document === 'undefined'){
                return;
            }
            if(newVal.length == 0){
                document.cookie = `ssCartProducts=;expires=${new Date(0).toUTCString()};`;
            }else{
                document.cookie = `ssCartProducts=${newVal};`;
            }
        }
    })

    function addViewedProduct(productId: string){
        let viewedProducts = ssViewedProducts.value;
        if(viewedProducts.includes(productId)){
            return;
        }
        if(viewedProducts.length >= 5){
            viewedProducts.pop();
        }
        viewedProducts.unshift(productId);
        ssViewedProducts.value = viewedProducts.filter(prod => prod != '').join(',');
    }

    function addCartProduct(productId: string){
        let cartProducts = ssCartProducts.value;
        if(cartProducts.includes(productId)){
            return;
        }
        cartProducts.push(productId);
        ssCartProducts.value = cartProducts.filter(prod => prod != '').join(',');
    }
    function clearCartProduct(productId: string){
        let cartProducts = ssCartProducts.value;
        cartProducts = cartProducts.filter(prod => prod != productId);
        ssCartProducts.value = cartProducts.filter(prod => prod != '').join(',');
    }
    
    function clearCartProducts(){
        ssCartProducts.value = [];
        ssCartProducts.value = '';
    }

    function addCartProducts(productIds: string[]){
        let cartProducts = ssCartProducts.value;
        productIds.forEach((productId)=>{
            if(cartProducts.includes(productId)){
                return;
            }
            cartProducts.push(productId);
        });
        ssCartProducts.value = cartProducts.filter(prod => prod != '').join(',');
    }
    
    return {
        ssViewedProducts,
        ssCartProducts,
        addViewedProduct,
        addCartProduct,
        addCartProducts,
        clearCartProduct,
        clearCartProducts
    }
});